















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import ContentImage from '@/components/ContentImage.vue'

@Component({
  components: { ContentImage },
})
export default class FeedContent extends Vue {
  @Prop({ type: String }) imgSrc !: string
  @Prop({ type: String }) title !: string

}

